import React, { type FunctionComponent, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { SVGIcon } from 'ic-snacks'
import styled from '@emotion/styled'
import { dashColors } from 'legacy/dash-blocks/foundation/colors'
import { Box, type BoxProps } from 'legacy/dash-blocks/box/Box'
import TextField from 'legacy/components/Forms/TextField'

const TextFieldContainer = styled(Box)`
  width: 230px;
  height: 10px,
  fontSize: 12px,
`

interface Props extends BoxProps {
  value?: string
  onChange: (nextValue: string) => void
}

export const OrderListFiltersByNumber: FunctionComponent<Props> = ({
  value = '',
  onChange,
  ...rest
}) => {
  const intl = useIntl()

  const handleChange = useCallback(
    ({ target: { value: nextValue } }) => onChange(nextValue),
    [onChange]
  )

  return (
    <TextFieldContainer {...rest}>
      <TextField
        value={value}
        onChange={handleChange}
        type="text"
        elementAttributes={{
          placeholder: intl.formatMessage({
            id: 'orders.search_order_number.placeholder',
          }),
        }}
        name="search-order-numbers"
        prefix={<SVGIcon name="search" color={dashColors.NEUTRAL} style={{ height: '18px' }} />}
      />
    </TextFieldContainer>
  )
}
